import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";
import { IContactsData } from "./types";

export const fetchContacts = createAsyncThunk<IContactsData | null>(
  "contacts/fetchContacts",
  async () => {
    try {
      const response = await axiosInstance.get(api.contacts.GET_CONTACTS);
      if (Array.isArray(response.data) && response.data.length > 0) {
        return response.data[0];
      }
      return null;
    } catch (error: any) {
      return null;
    }
  }
);

